// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.custom-modal1 {
  background-color: white;
  position: absolute;
  bottom: 0;
  border-radius: 20px 20px 0px 0px;
  transition: transform 0.3s ease;
  width: 100%;
}
.custom-modal1 .close-button {
  position: absolute;
  top: -2.5rem;
  right: 10px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.filter-section1 {
  font-size: 29px;
}

.filter-section {
  padding-block: 2.5rem;
  padding-left: 2rem;
}
.filter-section .filter-title {
  font-size: 18px;
  font-weight: 600;
}
.filter-section .type-month {
  padding-block: 2rem;
}
.filter-section .type p,
.filter-section .month p {
  font-size: 14px;
  padding-block: 1rem;
}
.filter-section .type div,
.filter-section .month div {
  display: flex;
  gap: 10px;
  font-size: 12px;
}
.filter-section .type :focus,
.filter-section .month :focus {
  border: none;
  background-color: #e6f7ef;
  color: #00aa74;
}
.filter-section .month > div {
  overflow-y: scroll;
}
.filter-section .Btn-filter {
  display: flex;
  justify-content: space-between;
  margin-right: 2rem;
  font-size: 14px;
}
.filter-section .Btn-filter button {
  border-radius: 8px;
  padding: 10px 24px;
  background-color: #d9d9d9;
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #8c8c8c;
}
.filter-section .Btn-filter .apply-btn > button {
  background-color: #00aa74;
  color: white;
}
.filter-section .Btn-filter .inactivebtn > button {
  background-color: #D9D9D9;
}
.filter-section .Btn-filter .clear-btn > button {
  border: 1px solid #00aa74;
  color: #00aa74;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/FilterTransactions/style.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;AAAJ;AACI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AACR;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,eAAA;EACA,gBAAA;AAAR;AAEI;EACI,mBAAA;AAAR;AAIQ;;EACI,eAAA;EACA,mBAAA;AADZ;AAGQ;;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAAZ;AAEQ;;EACI,YAAA;EACA,yBCjCM;EDkCN,cC3DI;AD4DhB;AAGI;EACI,kBAAA;AADR;AAGI;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AADR;AAEQ;EACI,kBAAA;EACA,kBAAA;EACA,yBC3DK;ED4DL,uBAAA;EACA,yBAAA;EACA,cAAA;AAAZ;AAEQ;EACI,yBChFI;EDiFJ,YAAA;AAAZ;AAEQ;EACI,yBAAA;AAAZ;AAEQ;EACI,yBAAA;EACA,cCxFI;ADwFhB","sourcesContent":["@import '../../../Styles/sass/variables';\n.custom-modal-overlay {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #00000099;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n}\n\n.custom-modal1 {\n    background-color: white;\n    position: absolute;\n    bottom: 0;\n    border-radius: 20px 20px 0px 0px;\n    transition: transform 0.3s ease;\n    width: 100%;\n    .close-button {\n        position: absolute;\n        top: -2.5rem;\n        right: 10px;\n        border: none;\n        background-color: transparent;\n        cursor: pointer;\n    }\n}\n\n.filter-section1 {\n    font-size: 29px;\n}\n\n.filter-section {\n    padding-block: 2.5rem;\n    padding-left: 2rem;\n\n    .filter-title {\n        font-size: 18px;\n        font-weight: 600;\n    }\n    .type-month {\n        padding-block: 2rem;\n    }\n    .type,\n    .month {\n        p {\n            font-size: 14px;\n            padding-block: 1rem;\n        }\n        div {\n            display: flex;\n            gap: 10px;\n            font-size: 12px;\n        }\n        :focus{\n            border: none;\n            background-color: $color_green_100;\n            color: $primary_green;\n        }\n    }\n\n    .month > div {\n        overflow-y: scroll;\n    }\n    .Btn-filter {\n        display: flex;\n        justify-content: space-between;\n        margin-right: 2rem;\n        font-size: 14px;\n        button {\n            border-radius: 8px;\n            padding: 10px 24px;\n            background-color: $color_grey_200;\n            background-color: white;\n            border: 1px solid $color_grey_200;\n            color: #8c8c8c; \n        }\n        .apply-btn > button {\n            background-color: $primary_green;\n            color: white;\n        }\n        .inactivebtn>button{\n            background-color: #D9D9D9;\n        }\n        .clear-btn>button{\n            border: 1px solid $primary_green;\n            color: $primary_green;\n        }\n    }\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
